import { getCacheInfo } from './cache';
import capitalize from './lodash/capitalize';
import createEventHub from './lodash/createEventHub';
import { mapError } from './logger';
/**
 * lbs sdk api 消息总线
 */
var mapApiEmitter = createEventHub();
/**
 * 缓存命中消息
 *
 * ```
 * // 命中缓存的时候，向外发送命中消息
 * cacheEmit('resultCache', 'cacheKey', response, options)
 *
 * // 监听
 * lbsEvents.on('cache:lbsDriveRouteByServer', (v) => {
 *   console.log('event => cache:lbsDriveRouteByServer', v);
 * });
 * ```
 */
function cacheEmit(cacheType, cacheKey, response, options) {
    // 加上 try catch，以防阻塞正常逻辑
    try {
        var fetchOptions = options.fetchOptions, geoHashCacheInfo = options.geoHashCacheInfo;
        var method = fetchOptions.method, serviceType = fetchOptions.serviceType, params = fetchOptions.params;
        var methodName = "lbs".concat(capitalize(method));
        var event_1 = "cache:".concat(methodName);
        var data = {
            cacheType: cacheType,
            cacheKey: cacheKey,
            methodName: methodName,
            serviceType: serviceType,
            response: response,
            geoHashCacheInfo: geoHashCacheInfo,
            resultCacheInfo: getCacheInfo(cacheKey),
            params: params,
        };
        mapApiEmitter.emit(event_1, data);
    }
    catch (e) {
        mapError('cache emit', e);
    }
}
export { mapApiEmitter, cacheEmit };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1pdHRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb3JlL3V0aWxzL2VtaXR0ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUN2QyxPQUFPLFVBQVUsTUFBTSxxQkFBcUIsQ0FBQztBQUM3QyxPQUFPLGNBQWMsTUFBTSx5QkFBeUIsQ0FBQztBQUNyRCxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBc0RwQzs7R0FFRztBQUNILElBQU0sYUFBYSxHQUFHLGNBQWMsRUFBa0IsQ0FBQztBQUV2RDs7Ozs7Ozs7Ozs7O0dBWUc7QUFDSCxTQUFTLFNBQVMsQ0FDaEIsU0FBb0IsRUFDcEIsUUFBNEIsRUFDNUIsUUFBaUIsRUFDakIsT0FBeUI7SUFFekIsd0JBQXdCO0lBQ3hCLElBQUk7UUFDTSxJQUFBLFlBQVksR0FBdUIsT0FBTyxhQUE5QixFQUFFLGdCQUFnQixHQUFLLE9BQU8saUJBQVosQ0FBYTtRQUMzQyxJQUFBLE1BQU0sR0FBMEIsWUFBWSxPQUF0QyxFQUFFLFdBQVcsR0FBYSxZQUFZLFlBQXpCLEVBQUUsTUFBTSxHQUFLLFlBQVksT0FBakIsQ0FBa0I7UUFDckQsSUFBTSxVQUFVLEdBQUcsYUFBTSxVQUFVLENBQUMsTUFBTSxDQUFDLENBQUUsQ0FBQztRQUM5QyxJQUFNLE9BQUssR0FBRyxnQkFBUyxVQUFVLENBQUUsQ0FBQztRQUNwQyxJQUFNLElBQUksR0FBbUI7WUFDM0IsU0FBUyxXQUFBO1lBQ1QsUUFBUSxVQUFBO1lBQ1IsVUFBVSxZQUFBO1lBQ1YsV0FBVyxhQUFBO1lBQ1gsUUFBUSxVQUFBO1lBQ1IsZ0JBQWdCLGtCQUFBO1lBQ2hCLGVBQWUsRUFBRSxZQUFZLENBQUMsUUFBUSxDQUFDO1lBQ3ZDLE1BQU0sUUFBQTtTQUNQLENBQUM7UUFFRixhQUFhLENBQUMsSUFBSSxDQUFDLE9BQUssRUFBRSxJQUFJLENBQUMsQ0FBQztLQUNqQztJQUFDLE9BQU8sQ0FBQyxFQUFFO1FBQ1YsUUFBUSxDQUFDLFlBQVksRUFBRSxDQUFDLENBQUMsQ0FBQztLQUMzQjtBQUNILENBQUM7QUFFRCxPQUFPLEVBQUUsYUFBYSxFQUFFLFNBQVMsRUFBRSxDQUFDIn0=